import React from "react"
import types from "prop-types"
import { useDispatch, useSelector } from "react-redux"
import {
  getFormQuestionAttributeUseSavedOptionsList,
  getFormQuestionCannotUseSavedOptions,
  setQuestionAttributeUseSavedOptionsList,
} from "reduxSlices/formBuilderSlice"
import { SwitchInput } from "shared/inputs"
import Tooltip, { BOTTOM_LEFT } from "shared/Tooltip"

const LOCKED_OPTION_TOOLTIP_TEXT = "Cannot use saved options if question or options are used in workflow, branching, or flag conditions."

const UseSavedOptionsList = ({ sectionIndex, questionIndex }) => {
  const dispatch = useDispatch()

  const useSavedOptionsList = useSelector(
    getFormQuestionAttributeUseSavedOptionsList({ sectionIndex, questionIndex }),
  )
  const cannotUseSavedOptions = useSelector(
    getFormQuestionCannotUseSavedOptions({ sectionIndex, questionIndex }),
  )

  const disabled = !useSavedOptionsList && cannotUseSavedOptions

  const updateUseSavedOptionsList = (newUseSavedOptionsList) => dispatch(setQuestionAttributeUseSavedOptionsList({
    sectionIndex, questionIndex, newUseSavedOptionsList,
  }))

  return (
    <div className="mb-4 flex-center">
      <div className="font-medium">Use saved options</div>
      <Tooltip text={disabled ? LOCKED_OPTION_TOOLTIP_TEXT : ""} position={BOTTOM_LEFT}>
        <SwitchInput
          value={useSavedOptionsList}
          onChange={updateUseSavedOptionsList}
          disabled={disabled}
        />
      </Tooltip>
    </div>
  )
}

UseSavedOptionsList.propTypes = {
  sectionIndex: types.number.isRequired,
  questionIndex: types.number.isRequired,
}

export default UseSavedOptionsList
